/**
 * Created by jv on 31/05/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");

let uploadService = {};

(function (UploadService) {
  UploadService.uploadFiles = function (files, successCb, failCb) {
    if (!utils.isArray(files)) {
      if (utils.isFunction(failCb)) {
        failCb();
      }

      return;
    }

    let url = utils.getServiceUrl("/upload");
    uploadFiles(url, files, successCb, failCb)
      .then((data) => {
        if (utils.isNotNull(data) && data.hasOwnProperty("data") && utils.isNotNull(data.data)) {
          var result = utils.parseJSON(data.data, true);

          if (utils.isFunction(successCb)) {
            successCb(result);
          }
        } else {
          if (utils.isFunction(failCb)) {
            failCb();
          }
        }
      })
      .catch((err) => {
        if (utils.isFunction(failCb)) {
          failCb(err);
        }
      });
  };

  UploadService.uploadResources = function (files, successCb, failCb) {
    let url = utils.getServiceUrl("/upload-resources");
    return uploadFiles(url, files, successCb, failCb);
  };

  function uploadFiles(url, files) {
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(files[i].name, files[i].data);
    }

    return request.post({
      url: url,
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      dataType: "json",
      enctype: "multipart/form-data"
    });
  }

}(uploadService));

module.exports = uploadService;



// WEBPACK FOOTER //
// ./app/js/services/upload-service.js